import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import commonType from "./actionTypes"

import moment from "moment"
import correctionAPI from "helpers/correction_backend_helper"
import CommonAction from "./actions"
import { getInfoMeAPI } from "helpers/users_backend_helper"
import CommonAPI from "helpers/commont_backend_helper"

function* getIgarashiInfo({ action }) {
  yield put(
    CommonAction.getIgarashiInfoSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(CommonAPI.getIgarashiInfo)

    if (action) {
      action(data)
    }
    yield put(
      CommonAction.getIgarashiInfoSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      CommonAction.getIgarashiInfoSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* commonSaga() {
  yield takeEvery(commonType.GET_INFO_IGARASHI, getIgarashiInfo)
}

export default commonSaga
